<script>
  import { onMount } from 'svelte'
  import Card from '/components/Atoms/Card.svelte'
  import IconCaret from '/Icons/IconCaret'

  let weather;

  onMount(async () => {
    await fetch(process.env.WEATHER_URL)
      .then(r => r.json())
      .then(data => {
        weather = data;
        console.log(weather)
      });
  })

  // source: https://api.met.no/weatherapi/weathericon/2.0/legends
  const terms_translations =
  {
    "sleetshowers":{
      "desc_nb":"Sluddbyger",
      "desc_nn":"Sluddbyer",
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "old_id":7,
      "desc_en":"Sleet showers"
    },
    "heavysleet":{
      "old_id":48,
      "desc_en":"Heavy sleet",
      "desc_nb":"Kraftig sludd",
      "desc_nn":"Kraftig sludd",
      "variants":null
    },
    "heavysleetshowersandthunder":{
      "desc_en":"Heavy sleet showers and thunder",
      "old_id":27,
      "desc_nb":"Kraftige sluddbyger og torden",
      "desc_nn":"Kraftige sluddbyer og torevêr",
      "variants":[
        "day",
        "night",
        "polartwilight"
      ]
    },
    "snow":{
      "old_id":13,
      "desc_en":"Snow",
      "desc_nb":"Snø",
      "desc_nn":"Snø",
      "variants":null
    },
    "heavysnowshowers":{
      "desc_nn":"Kraftige snøbyer",
      "desc_nb":"Kraftige snøbyger",
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "old_id":45,
      "desc_en":"Heavy snow showers"
    },
    "rainandthunder":{
      "old_id":22,
      "desc_en":"Rain and thunder",
      "variants":null,
      "desc_nn":"Regn og torevêr",
      "desc_nb":"Regn og torden"
    },
    "heavyrainshowers":{
      "desc_en":"Heavy rain showers",
      "old_id":41,
      "desc_nb":"Kraftige regnbyger",
      "desc_nn":"Kraftige regnbyer",
      "variants":[
        "day",
        "night",
        "polartwilight"
      ]
    },
    "heavyrain":{
      "desc_en":"Heavy rain",
      "old_id":10,
      "desc_nb":"Kraftig regn",
      "desc_nn":"Kraftig regn",
      "variants":null
    },
    "lightsnowshowers":{
      "desc_en":"Light snow showers",
      "old_id":44,
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "desc_nb":"Lette snøbyger",
      "desc_nn":"Lette snøbyer"
    },
    "partlycloudy":{
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "desc_nb":"Delvis skyet",
      "desc_nn":"Delvis skya",
      "old_id":3,
      "desc_en":"Partly cloudy"
    },
    "clearsky":{
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "desc_nn":"Klårvêr",
      "desc_nb":"Klarvær",
      "desc_en":"Clear sky",
      "old_id":1
    },
    "heavysnow":{
      "variants":null,
      "desc_nn":"Kraftig snø",
      "desc_nb":"Kraftig snø",
      "desc_en":"Heavy snow",
      "old_id":50
    },
    "fair":{
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "desc_nn":"Lettskya",
      "desc_nb":"Lettskyet",
      "desc_en":"Fair",
      "old_id":2
    },
    "snowshowers":{
      "old_id":8,
      "desc_en":"Snow showers",
      "desc_nn":"Snøbyer",
      "desc_nb":"Snøbyger",
      "variants":[
        "day",
        "night",
        "polartwilight"
      ]
    },
    "snowshowersandthunder":{
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "desc_nb":"Snøbyger og torden",
      "desc_nn":"Snøbyer og torevêr",
      "old_id":21,
      "desc_en":"Snow showers and thunder"
    },
    "sleetandthunder":{
      "variants":null,
      "desc_nb":"Sludd og torden",
      "desc_nn":"Sludd og torevêr",
      "desc_en":"Sleet and thunder",
      "old_id":23
    },
    "cloudy":{
      "desc_nb":"Skyet",
      "desc_nn":"Skya",
      "variants":null,
      "desc_en":"Cloudy",
      "old_id":4
    },
    "lightssleetshowersandthunder":{
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "desc_nn":"Lette sluddbyer og torevêr",
      "desc_nb":"Lette sluddbyger og torden",
      "old_id":26,
      "desc_en":"Light sleet showers and thunder"
    },
    "heavysnowandthunder":{
      "desc_en":"Heavy snow and thunder",
      "old_id":34,
      "desc_nb":"Kraftig snø og torden",
      "desc_nn":"Kraftig snø og torevêr",
      "variants":null
    },
    "heavyrainshowersandthunder":{
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "desc_nb":"Kraftige regnbyger og torden",
      "desc_nn":"Kraftige regnbyer og torevêr",
      "desc_en":"Heavy rain showers and thunder",
      "old_id":25
    },
    "rain":{
      "desc_en":"Rain",
      "old_id":9,
      "variants":null,
      "desc_nb":"Regn",
      "desc_nn":"Regn"
    },
    "lightrain":{
      "old_id":46,
      "desc_en":"Light rain",
      "variants":null,
      "desc_nn":"Lett regn",
      "desc_nb":"Lett regn"
    },
    "fog":{
      "desc_nb":"Tåke",
      "desc_nn":"Skodde",
      "variants":null,
      "desc_en":"Fog",
      "old_id":15
    },
    "lightrainshowersandthunder":{
      "desc_nb":"Lette regnbyger og torden",
      "desc_nn":"Lette regnbyer og torevêr",
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "old_id":24,
      "desc_en":"Light rain showers and thunder"
    },
    "snowandthunder":{
      "desc_en":"Snow and thunder",
      "old_id":14,
      "variants":null,
      "desc_nn":"Snø og torevêr",
      "desc_nb":"Snø og torden"
    },
    "lightsleet":{
      "variants":null,
      "desc_nn":"Lett sludd",
      "desc_nb":"Lett sludd",
      "old_id":47,
      "desc_en":"Light sleet"
    },
    "sleetshowersandthunder":{
      "desc_nn":"Sluddbyer og torevêr",
      "desc_nb":"Sluddbyger og torden",
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "old_id":20,
      "desc_en":"Sleet showers and thunder"
    },
    "lightsleetshowers":{
      "desc_en":"Light sleet showers",
      "old_id":42,
      "desc_nb":"Lette sluddbyger",
      "desc_nn":"Lette sluddbyer",
      "variants":[
        "day",
        "night",
        "polartwilight"
      ]
    },
    "heavysleetshowers":{
      "old_id":43,
      "desc_en":"Heavy sleet showers",
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "desc_nn":"Kraftige sluddbyer",
      "desc_nb":"Kraftige sluddbyger"
    },
    "lightsnow":{
      "variants":null,
      "desc_nn":"Lett snø",
      "desc_nb":"Lett snø",
      "old_id":49,
      "desc_en":"Light snow"
    },
    "heavysleetandthunder":{
      "variants":null,
      "desc_nb":"Kraftig sludd og torden",
      "desc_nn":"Kraftig sludd og torevêr",
      "old_id":32,
      "desc_en":"Heavy sleet and thunder"
    },
    "lightssnowshowersandthunder":{
      "desc_nb":"Lette snøbyger og torden",
      "desc_nn":"Lette snøbyer og torevêr",
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "old_id":28,
      "desc_en":"Light snow showers and thunder"
    },
    "sleet":{
      "variants":null,
      "desc_nn":"Sludd",
      "desc_nb":"Sludd",
      "old_id":12,
      "desc_en":"Sleet"
    },
    "rainshowersandthunder":{
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "desc_nb":"Regnbyger og torden",
      "desc_nn":"Regnbyer og torevêr",
      "old_id":6,
      "desc_en":"Rain showers and thunder"
    },
    "heavyrainandthunder":{
      "old_id":11,
      "desc_en":"Heavy rain and thunder",
      "desc_nb":"Kraftig regn og torden",
      "desc_nn":"Kraftig regn og torevêr",
      "variants":null
    },
    "heavysnowshowersandthunder":{
      "old_id":29,
      "desc_en":"Heavy snow showers and thunder",
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "desc_nb":"Kraftige snøbyger og torden",
      "desc_nn":"Kraftige snøbyer og torevêr"
    },
    "lightrainandthunder":{
      "variants":null,
      "desc_nn":"Lett regn og torevêr",
      "desc_nb":"Lett regn og torden",
      "old_id":30,
      "desc_en":"Light rain and thunder"
    },
    "lightsleetandthunder":{
      "desc_en":"Light sleet and thunder",
      "old_id":31,
      "desc_nb":"Lett sludd og torden",
      "desc_nn":"Lett sludd og torevêr",
      "variants":null
    },
    "lightsnowandthunder":{
      "variants":null,
      "desc_nn":"Lett snø og torevêr",
      "desc_nb":"Lett snø og torden",
      "old_id":33,
      "desc_en":"Light snow and thunder"
    },
    "rainshowers":{
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "desc_nn":"Regnbyer",
      "desc_nb":"Regnbyger",
      "desc_en":"Rain showers",
      "old_id":5
    },
    "lightrainshowers":{
      "variants":[
        "day",
        "night",
        "polartwilight"
      ],
      "desc_nb":"Lette regnbyger",
      "desc_nn":"Lette regnbyer",
      "old_id":40,
      "desc_en":"Light rain showers"
    }
  }

  const translate_term = term => {
    const term_without_variant = term.split("_")?.[0] || ""
    return terms_translations[term_without_variant]?.desc_en || term_without_variant
  }

</script>

{#if weather}
  <Card paddingStyle="moon">
    <div class="content">
      <h3 class="title">
        Weather (Berlin)
      </h3>
      <strong class="temperature" title="Temperature">
        {weather.temperature}&thinsp;°
      </strong>
      <div class="term">
        {translate_term(weather.term)}
      </div>
      <span class="sun">
        Sun: 
          <span title="sunrise">
            <IconCaret />{weather.sunrise}
          </span>
          <span title="sunset">
            <IconCaret down />{weather.sunset}
          </span>
      </span>
    </div>
  </Card>
{/if}

<style lang="scss">

  .content {
    @include typo-serif-text-28;
    height: 200px;
    display: grid;
    grid-template-rows: 1em auto 1em;
    grid-template-columns: 1fr 1fr;
    

    .title {
      grid-row: 1;
      grid-column: 1 / span 2;
    }

    .temperature {
      @include typo-serif-temperature;
      grid-row: 2;
      grid-column: 1;
      align-self: center;
    }
      
    .term {
      grid-row: 3;
      grid-column: 1;
      align-self: end;
      
    }
    .sun {
      grid-row: 3;
      grid-column: 1 / span 2;
      justify-self: end;
      align-self: end;
      text-align: right;
      @include media-large-and-less {
        width: 4em;
      }
      span {
        white-space: nowrap;
      }
    }
  }

</style>

